import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { gasService, isGasOracleSupported } from "../../services/gas.js";
/**
 * React hook to fetch current gas price for a chain.
 *
 * @param chainId - The chain ID to fetch gas price for
 * @param options - Optional configuration
 *
 * @example
 * ```tsx
 * const { gasPrice, isSpike, isLoading } = useGasPrice(8453); // Base
 *
 * if (isSpike) {
 *   return <Warning>Gas prices are high: {gasPrice?.recommendation}</Warning>;
 * }
 * ```
 */
export function useGasPrice(chainId, t0) {
  const $ = _c(19);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const options = t1;
  const {
    refetchInterval: t2,
    enabled
  } = options;
  const refetchInterval = t2 === undefined ? 10000 : t2;
  let t3;
  if ($[2] !== chainId) {
    t3 = chainId !== undefined && isGasOracleSupported(chainId);
    $[2] = chainId;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const isSupported = t3;
  const queryEnabled = enabled ?? isSupported;
  let t4;
  let t5;
  if ($[4] !== chainId) {
    t4 = ["gasPrice", chainId];
    t5 = () => gasService.fetch(chainId);
    $[4] = chainId;
    $[5] = t4;
    $[6] = t5;
  } else {
    t4 = $[5];
    t5 = $[6];
  }
  const t6 = queryEnabled && chainId !== undefined;
  let t7;
  if ($[7] !== refetchInterval || $[8] !== t4 || $[9] !== t5 || $[10] !== t6) {
    t7 = {
      queryKey: t4,
      queryFn: t5,
      enabled: t6,
      refetchInterval,
      staleTime: 5000,
      retry: 2,
      refetchOnWindowFocus: true
    };
    $[7] = refetchInterval;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const {
    data,
    isLoading,
    isError,
    error,
    refetch
  } = useQuery(t7);
  let t8;
  const t9 = data?.isSpike ?? false;
  let t10;
  if ($[12] !== data || $[13] !== error || $[14] !== isError || $[15] !== isLoading || $[16] !== refetch || $[17] !== t9) {
    t10 = {
      gasPrice: data,
      isLoading,
      isError,
      error,
      isSpike: t9,
      refetch
    };
    $[12] = data;
    $[13] = error;
    $[14] = isError;
    $[15] = isLoading;
    $[16] = refetch;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  t8 = t10;
  return t8;
}